// bootstrap javascript
import "bootstrap"

// script
import Kernel from "./ts/kernel"
new Kernel()

// stylesheet
import "bootstrap-icons/font/bootstrap-icons.scss"
// import "./scss/_bootstrap.scss"
// import "bootstrap/scss/bootstrap.scss"
import "./scss/app.scss"
// import "./scss/_config.scss"
import "./scss/layout.scss"
import "./scss/editor.scss"
